import { initTestimonials } from "../modules/testimonials.js";

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initTestimonials, { once: true });
} else {
  initTestimonials();
}
